var _circle, _circle2, _g, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhotoDefault(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 96,
    height: 96,
    viewBox: "0 0 96 96",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#E9EAEE"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3532_4115",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 96,
    height: 96
  }, _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 48,
    cy: 48,
    r: 48,
    fill: "#F6F2E1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3532_4115)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M50.8265 37.3337L53.2665 40.0003H58.6665V56.0003H37.3332V40.0003H42.7332L45.1732 37.3337H50.8265ZM51.9998 34.667H43.9998L41.5598 37.3337H37.3332C35.8665 37.3337 34.6665 38.5337 34.6665 40.0003V56.0003C34.6665 57.467 35.8665 58.667 37.3332 58.667H58.6665C60.1332 58.667 61.3332 57.467 61.3332 56.0003V40.0003C61.3332 38.5337 60.1332 37.3337 58.6665 37.3337H54.4398L51.9998 34.667ZM47.9998 44.0003C50.1998 44.0003 51.9998 45.8003 51.9998 48.0003C51.9998 50.2003 50.1998 52.0003 47.9998 52.0003C45.7998 52.0003 43.9998 50.2003 43.9998 48.0003C43.9998 45.8003 45.7998 44.0003 47.9998 44.0003ZM47.9998 41.3337C44.3198 41.3337 41.3332 44.3203 41.3332 48.0003C41.3332 51.6803 44.3198 54.667 47.9998 54.667C51.6798 54.667 54.6665 51.6803 54.6665 48.0003C54.6665 44.3203 51.6798 41.3337 47.9998 41.3337Z",
    fill: "#ACB1B6"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotoDefault);
export default __webpack_public_path__ + "static/media/photo_default.626fd257015a0dabb0096e1f4af0732a.svg";
export { ForwardRef as ReactComponent };